/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Target_File_MissingInputs */

const vi_error_shop_target_file_missing = /** @type {(inputs: Error_Shop_Target_File_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh này không còn trên máy chủ — tải ảnh lên lại.`)
};

/**

* @param {Error_Shop_Target_File_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_target_file_missing = /** @type {((inputs?: Error_Shop_Target_File_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Target_File_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_target_file_missing(inputs)
});